import './App.css';
import { useState, useEffect } from 'react';
import { ethers, BigNumber, utils } from 'ethers';
import config from './config';
import IERC20 from './artifacts/contracts/IERC20.sol/IERC20.json';

// Update with the contract address logged out to the CLI when it was deployed 
const platformToken = utils.getAddress(config.addresses.token);
const polyPlatformToken = utils.getAddress(config.addresses.pToken);
const holderToken = utils.getAddress(config.addresses.holderToken);
const polyHolderToken = utils.getAddress(config.addresses.pHolderToken);
var provider = null;
var polyProvider = null;

const dailyBlocksETH = ~~(86400 / 14);
const dailyBlocksPoly = ~~(86400 / 2.3);

function App() {
  // store greeting in local state
  const [balances, setBalances] = useState();
  const [historic, setHistoric] = useState();

  async function getProvider() {
    console.log("Fetch eth provider");
    if(provider != null) {
      console.log("provider already initiated, returning cached provider");
      return provider;
    }
    const _provider = (typeof window.ethereum !== 'undefined') ? 
            new ethers.providers.Web3Provider(window.ethereum) :
            new ethers.providers.InfuraProvider('homestead', '491390fef53e480bb781394d88bbdf88');
    
    var network = await _provider.getNetwork();

    if(network.chainId !== 1) {
      console.log("wrong chainId on web3 wallet, fallback to infura endpoint");
      provider = new ethers.providers.InfuraProvider('homestead', '491390fef53e480bb781394d88bbdf88');
      network = await provider.getNetwork();
    } else {
      provider = _provider;
    }

    return provider;
  }

  async function getPolyProvider() {
    console.log("Fetch poly provider");
    if(polyProvider != null) {
      console.log("polygon provider already initiated, returning cached provider");
      return polyProvider;
    }

    const _polyProvider = (typeof window.ethereum !== 'undefined') ? 
            new ethers.providers.Web3Provider(window.ethereum) :
            new ethers.providers.JsonRpcProvider('https://polygon-rpc.com');
    
    var network = await _polyProvider.getNetwork();

    if(network.chainId !== 137) {
      console.log("wrong chainId on web3 wallet, fallback to poly rpc endpoint");
      polyProvider =  new ethers.providers.JsonRpcProvider('https://polygon-rpc.com');
    } else {
      polyProvider = _polyProvider;
    }

    return polyProvider;
  }

  async function getTokenContract() {
    console.log("ZCX", platformToken);
    return new ethers.Contract(platformToken, IERC20.abi, await getProvider());
  }

  async function getPolyTokenContract() {
    console.log("pZCX", polyPlatformToken);
    return new ethers.Contract(polyPlatformToken, IERC20.abi, await getPolyProvider());
  }

  async function getHolderTokenContract() {
    console.log("ZCXHT",holderToken);
    return new ethers.Contract(holderToken, IERC20.abi, await getProvider());
  }

  async function getPolyHolderTokenContract() {
    console.log("pZCXHT", polyHolderToken);
    return new ethers.Contract(polyHolderToken, IERC20.abi, await getPolyProvider());
  }

  function truncate(str, maxDecimalDigits) {
    if (str.includes('.')) {
        const parts = str.split('.');
        return parts[0] + '.' + parts[1].slice(0, maxDecimalDigits);
    }
    return str;
}

  function convertBigNumberToFormattedString(bn) {
    return truncate(utils.commify(utils.formatUnits(bn)),2);
  }

  function checkNegativeOrAddSign(v) {
    if(v.indexOf("-") === -1) {
      v = "+"+v;
    }
    return v;
  }

  async function fetchPrice() {

    let res = await fetch('https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0xc52c326331e9ce41f04484d3b5e5648158028804&vs_currencies=usd');
    let json = await res.json();

    return json[config.addresses.token].usd;
  }

  async function fetchData(block) {
    // const contract = await getTokenContract();
    // const holderToken = await getHolderTokenContract();
    // const polyContract = await getPolyTokenContract();
    // const polyHolderToken = await getPolyHolderTokenContract();
    const [
      zcxContract,
      zcxhtContract,
      pzcxContract,
      pzcxhtContract
    ] = await Promise.all([
      getTokenContract(),
      getHolderTokenContract(),
      getPolyTokenContract(),
      getPolyHolderTokenContract()
    ]);

    let price = 0;
    try {
      price = await fetchPrice();
    } catch (err) {
      console.log("PriceError: ", err);
    }

    const totalSupply = utils.parseEther('1000000000');

    try {
      
      const [
        realSupply,
        lpoolWallet,
        teamWallet,
        partnerWallet,
        daoWallet,
        presaleWallet,
        foundationWallet,
        stakingLPOOL,
        stakingUnizen,
        stakingUnizenHistoric,
        stakingUnizenHolderToken,
        stakingUnizenHolderTokenHistoric,
        burned2,
        bridgedZCX,
        bridgedZCX2,
        bridgedZCXHT,
        bridgedZCXHT2,
        stakedPolyToken,
        stakedPolyTokenHistoric,
        stakedPolyHolderToken,
        stakedPolyHolderTokenHistoric
      ] = await Promise.all([
        zcxContract.totalSupply(),
        zcxContract.balanceOf(utils.getAddress(config.wallets.lpool)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.team)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.partners)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.dao)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.presale)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.foundation)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.stakingLPOOL)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen), {blockTag: -dailyBlocksETH}),
        zcxhtContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen)),
        zcxhtContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen), {blockTag: -dailyBlocksETH}),
        zcxContract.balanceOf(utils.getAddress(config.wallets.burn2)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.bridge)),
        zcxContract.balanceOf(utils.getAddress(config.wallets.bridge2)),
        zcxhtContract.balanceOf(utils.getAddress(config.wallets.bridge)),
        zcxhtContract.balanceOf(utils.getAddress(config.wallets.bridge2)),
        //holderToken.balanceOf(utils.getAddress(config.wallets.bridge)),
        //zcxhtContract.balanceOf(utils.getAddress(config.wallets.bridge)),
        pzcxContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen)),
        pzcxContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen), {blockTag: -dailyBlocksPoly}),
        pzcxhtContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen)),
        pzcxhtContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen), {blockTag: -dailyBlocksPoly}),
        //polyHolderToken.balanceOf(utils.getAddress(config.wallets.pStakingUnizen))
      ]);

      const _launchpool     = BigNumber.from(lpoolWallet),
            _team           = BigNumber.from(teamWallet),
            _dao            = BigNumber.from(daoWallet),
            _partners       = BigNumber.from(partnerWallet),
            _presale        = BigNumber.from(presaleWallet.sub(stakingUnizenHolderToken)),
            _foundation     = BigNumber.from(foundationWallet),
            _total          = BigNumber.from(totalSupply),
            _stakingLPOOL   = BigNumber.from(stakingLPOOL),
            _stakingUnizenZCX = BigNumber.from(stakingUnizen),
            _stakingUnizenHT  = BigNumber.from(stakingUnizenHolderToken),
            _stakingUnizenPZCX  = BigNumber.from(stakedPolyToken),
            _stakingUnizenPZCXHT =  BigNumber.from(stakedPolyHolderToken),
            _stakingUnizen  = BigNumber.from(stakingUnizen.add(stakingUnizenHolderToken).add(stakedPolyToken).add(stakedPolyHolderToken)),
            _burned         = BigNumber.from(_total.sub(realSupply)),
            _burned2        = BigNumber.from(burned2),
            _bridgedZCX     = BigNumber.from(bridgedZCX.add(bridgedZCX2)),
            _bridgedZCXHT   = BigNumber.from(bridgedZCXHT.add(bridgedZCXHT2)),
            _totalBridged   = BigNumber.from(bridgedZCX.add(bridgedZCXHT).add(bridgedZCX2).add(bridgedZCXHT2)),
            _stakingUnizenZCXHistoric = BigNumber.from(stakingUnizenHistoric),
            _stakingUnizenZCXHTHistoric = BigNumber.from(stakingUnizenHolderTokenHistoric),
            _stakingUnizenPZCXHistoric = BigNumber.from(stakedPolyTokenHistoric),
            _stakingUnizenPZCXHTHistoric = BigNumber.from(stakedPolyHolderTokenHistoric),
            _stakingUnizenHistoric = BigNumber.from(stakingUnizenHistoric.add(stakingUnizenHolderTokenHistoric).add(stakedPolyHolderTokenHistoric).add(stakedPolyTokenHistoric)),
            _stakingDiff = _stakingUnizen.sub(_stakingUnizenHistoric),
            _stakingZCXDiff = BigNumber.from(stakingUnizen.sub(stakingUnizenHistoric)),
            _stakingZCXHTDiff = BigNumber.from(stakingUnizenHolderToken.sub(stakingUnizenHolderTokenHistoric)),
            _stakingPZCXDiff = BigNumber.from(stakedPolyToken.sub(stakedPolyTokenHistoric)),
            _stakingPZCXHTDiff = BigNumber.from(stakedPolyHolderToken.sub(stakedPolyHolderTokenHistoric));


      const _totalBurned = _burned.add(_burned2);

      let _circulating  = _total
                          .sub(_launchpool)
                          .sub(_team)
                          .sub(_dao)
                          .sub(_partners)
                          .sub(_presale)
                          .sub(_foundation)
                          .sub(_stakingLPOOL)
                          .sub(_stakingUnizenZCX)
                          .sub(_stakingUnizenPZCX)
                          .sub(_totalBurned);
                          //.add(_bridgedZCX);

      let mc  = (price > 0) ? _circulating.mul(BigNumber.from(~~(Math.ceil(price*100)))).div(100) : 0;
      let fdv = (price > 0) ? realSupply.mul(BigNumber.from(~~(Math.ceil(price*100)))).div(100) : 0;

      setBalances({
        total: convertBigNumberToFormattedString(_total),
        max: convertBigNumberToFormattedString(realSupply),
        launchpool: convertBigNumberToFormattedString(_launchpool),
        team: convertBigNumberToFormattedString(_team),
        partners: convertBigNumberToFormattedString(_partners),
        foundation: convertBigNumberToFormattedString(_foundation),
        presale: convertBigNumberToFormattedString(_presale),
        dao: convertBigNumberToFormattedString(_dao),
        stakingLPOOL: convertBigNumberToFormattedString(_stakingLPOOL),
        stakingUnizen: convertBigNumberToFormattedString(_stakingUnizen),
        stakingZCX: convertBigNumberToFormattedString(_stakingUnizenZCX),
        stakingZCXHT: convertBigNumberToFormattedString(_stakingUnizenHT),
        stakingPZCX: convertBigNumberToFormattedString(_stakingUnizenPZCX),
        stakingPZCXHT: convertBigNumberToFormattedString(_stakingUnizenPZCXHT),
        circulating: convertBigNumberToFormattedString(_circulating),
        burned: convertBigNumberToFormattedString(_totalBurned),
        price: price,
        mc: convertBigNumberToFormattedString(mc),
        fdv: convertBigNumberToFormattedString(fdv),
        bridgedZCX: convertBigNumberToFormattedString(_bridgedZCX),
        bridgedZCXHT: convertBigNumberToFormattedString(_bridgedZCXHT),
        totalBridged: convertBigNumberToFormattedString(_totalBridged),
        stakingUnizenZCXHistoric: convertBigNumberToFormattedString(_stakingUnizenZCXHistoric),
        stakingUnizenZCXHTHistoric: convertBigNumberToFormattedString(_stakingUnizenZCXHTHistoric),
        stakingUnizenPZCXHistoric: convertBigNumberToFormattedString(_stakingUnizenPZCXHistoric), 
        stakingUnizenPZCXHTHistoric: convertBigNumberToFormattedString(_stakingUnizenPZCXHTHistoric),
        stakingUnizenHistoric: convertBigNumberToFormattedString(_stakingUnizenHistoric),
        stakingDiff: checkNegativeOrAddSign(convertBigNumberToFormattedString(_stakingDiff)),
        stakingZCXDiff: checkNegativeOrAddSign(convertBigNumberToFormattedString(_stakingZCXDiff)),
        stakingZCXHTDiff: checkNegativeOrAddSign(convertBigNumberToFormattedString(_stakingZCXHTDiff)),
        stakingPZCXDiff: checkNegativeOrAddSign(convertBigNumberToFormattedString(_stakingPZCXDiff)),
        stakingPZCXHTDiff: checkNegativeOrAddSign(convertBigNumberToFormattedString(_stakingPZCXHTDiff))
      });

    } catch (err) {
      console.log("Error: ", err);
      alert('Fetching data failed with error: '+err);
    }
    
  }

  async function fetchHistoricData(days) {
    const [
      zcxContract,
      zcxhtContract,
      pzcxContract,
      pzcxhtContract
    ] = await Promise.all([
      getTokenContract(),
      getHolderTokenContract(),
      getPolyTokenContract(),
      getPolyHolderTokenContract()
    ]);

    try {
      if(!days) days = 5;

      var historicData = [];

      for(var i = 0; i <= days; i++) {
        const blockDataETH = (i === 0) ? 'latest' : -(i * dailyBlocksETH);
        const blockDataPoly = (i === 0) ? 'latest' : -(i * dailyBlocksPoly);
        const [
          stakingZCX,
          stakingZCXHT,
          bridgedZCX,
          bridgedZCX2,
          bridgedZCXHT,
          bridgedZCXHT2,
          stakingPZCX,
          stakingPZCXHT
        ] = await Promise.all([
          zcxContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen), {blockTag: blockDataETH}),
          zcxhtContract.balanceOf(utils.getAddress(config.wallets.stakingUnizen), {blockTag: blockDataETH}),
          zcxContract.balanceOf(utils.getAddress(config.wallets.bridge), {blockTag: blockDataETH}),
          zcxContract.balanceOf(utils.getAddress(config.wallets.bridge2), {blockTag: blockDataETH}),
          zcxhtContract.balanceOf(utils.getAddress(config.wallets.bridge), {blockTag: blockDataETH}),
          zcxhtContract.balanceOf(utils.getAddress(config.wallets.bridge2), {blockTag: blockDataETH}),
          pzcxContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen), {blockTag: blockDataPoly}),
          pzcxhtContract.balanceOf(utils.getAddress(config.wallets.pStakingUnizen), {blockTag: blockDataPoly}),
        ]);

        var dailyData = [];
        dailyData['stakedZCX'] = BigNumber.from(stakingZCX);
        dailyData['stakedZCXHT'] = BigNumber.from(stakingZCXHT);
        dailyData['stakedPZCX'] = BigNumber.from(stakingPZCX);
        dailyData['stakedPZCXHT'] = BigNumber.from(stakingPZCXHT);
        dailyData['bridgedZCX'] = BigNumber.from(bridgedZCX.add(bridgedZCX2));
        dailyData['bridgedZCXHT'] = BigNumber.from(bridgedZCXHT.add(bridgedZCXHT2));
        dailyData['totalStaked'] = BigNumber.from(dailyData['stakedZCX'].add(dailyData['stakedZCXHT']).add(dailyData['stakedPZCX']).add(dailyData['stakedPZCXHT']));
        dailyData['totalBridged'] = BigNumber.from(dailyData['bridgedZCX'].add(dailyData['bridgedZCXHT']));

        // if(i !== 0) {
        //   dailyData['stakedZCX'] = dailyData['stakedZCX'].sub(historicData[i-1]['stakedZCX']);
        //   dailyData['stakedZCXHT'] = dailyData['stakedZCXHT'].sub(historicData[i-1]['stakedZCXHT']);
        //   dailyData['stakedPZCX'] = dailyData['stakedPZCX'].sub(historicData[i-1]['stakedPZCX']);
        //   dailyData['stakedPZCXHT'] = dailyData['stakedPZCXHT'].sub(historicData[i-1]['stakedPZCXHT']);
        //   dailyData['bridgedZCX'] = dailyData['bridgedZCX'].sub(historicData[i-1]['bridgedZCX']);
        //   dailyData['bridgedZCXHT'] = dailyData['bridgedZCXHT'].sub(historicData[i-1]['bridgedZCXHT']);
        //   dailyData['totalStaked'] = dailyData['totalStaked'].sub(historicData[i-1]['totalStaked']);
        //   dailyData['totalBridged'] = dailyData['totalBridged'].sub(historicData[i-1]['totalBridged']);
        // }

        historicData[i] = dailyData;

      }

      setHistoric(historicData);

    } catch(err) {
      console.log("Error: ", err);
      alert('Fetching data failed with error: '+err);
    }
  }

  function ShowHistoricTable({ b }) {
    if(typeof b === 'undefined' ) {
      b = [];
    }

    var rows = [];

    if(b.length > 0) {
      for(var i = 0; i < b.length; i++) {
        rows[i] = GetHistoricTableRow(i, b[i]);
      }
    } else {
      rows = GetEmptyRow();
    }

    return (<table id="historicTable">
      <thead>
        <tr>
          <th>Day</th>
          <th>Total staked</th>
          <th>Staked ZCX</th>
          <th>Staked ZCXHT</th>
          <th>Staked pZCX</th>
          <th>Staked pZCXHT</th>
          <th>Total bridged</th>
          <th>Bridged ZCX</th>
          <th>Bridged ZCXHT</th>
        </tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </table>);
  }

  function GetEmptyRow() {
    return (
      <tr key="emptyRow">
        <td colSpan="9">No data loaded yet</td>
      </tr>
    );
  }

  function GetHistoricTableRow(day, row) {
    if(!row) return null;

    return (
      <tr key={"row"+day}>
        <td>{(day === 0) ? 'Now' : -day}</td>
        <td>{convertBigNumberToFormattedString(row['totalStaked'])}</td>
        <td>{convertBigNumberToFormattedString(row['stakedZCX'])}</td>
        <td>{convertBigNumberToFormattedString(row['stakedZCXHT'])}</td>
        <td>{convertBigNumberToFormattedString(row['stakedPZCX'])}</td>
        <td>{convertBigNumberToFormattedString(row['stakedPZCXHT'])}</td>
        <td>{convertBigNumberToFormattedString(row['totalBridged'])}</td>
        <td>{convertBigNumberToFormattedString(row['bridgedZCX'])}</td>
        <td>{convertBigNumberToFormattedString(row['bridgedZCXHT'])}</td>

      </tr>
    );
  }

  function ShowBalanceTable({ b }) {
    if(typeof b === 'undefined') {
      b = {
        price:0,
        mc:0,
        fdv:0,
        max:0,
        total:0,
        team: 0,
        partners: 0,
        foundation: 0,
        dao:0,
        presale:0,
        launchpool:0,
        circulating:0,
        stakingLPOOL:0,
        stakingUnizen:0,
        stakingZCX:0,
        stakingZCXHT:0,
        stakingPZCX:0,
        stakingPZCXHT:0,
        burned:0,
        totalBridged:0,
        bridgedZCX:0,
        bridgedZCXHT:0,
        stakingUnizenZCXHistoric: 0,
        stakingUnizenZCXHTHistoric: 0,
        stakingUnizenPZCXHistoric: 0, 
        stakingUnizenPZCXHTHistoric: 0,
        stakingUnizenHistoric: 0,
        stakingDiff: 0,
        stakingZCXDiff: 0,
        stakingZCXHTDiff: 0,
        stakingPZCXDiff: 0,
        stakingPZCXHTDiff: 0
      };
    }
    return (
      <table id="supplyTable">
          <thead>
            <tr>
              <th>Description</th>
              <th>Tokens</th>
            </tr>
            <tr>
              <th>Initial Total Supply</th>
              <th>{b.total||0} ZCX</th>
            </tr>
            <tr>
              <th>Total Supply</th>
              <th>{b.max||0} ZCX</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Team</td>
              <td>- {b.team||0} ZCX</td>
            </tr>
            <tr>
              <td>Partners &amp; Advisors</td>
              <td>- {b.partners||0} ZCX</td>
            </tr>
            <tr>
              <td>DAO / Ecosystem reserve</td>
              <td>- {b.dao||0} ZCX</td>
            </tr>
            <tr>
              <td>Foundation</td>
              <td>- {b.foundation||0} ZCX</td>
            </tr>
            <tr>
              <td>Presale</td>
              <td>- {b.presale||0} ZCX</td>
            </tr>
            <tr>
              <td>Launchpool AME</td>
              <td>- {b.launchpool||0} ZCX</td>
            </tr>
            <tr>
              <td>Staking - LPOOL</td>
              <td>- {b.stakingLPOOL || 0} ZCX</td>
            </tr>
            <tr>
              <td>Staking - DMAS</td>
              <td>{b.stakingUnizen || 0} ZCX <sup>({b.stakingDiff || 0})</sup><br />
              <small>- {b.stakingZCX || 0} ZCX <sup>({b.stakingZCXDiff || 0})</sup><br />
              {b.stakingZCXHT || 0} ZCXHT <sup>({b.stakingZCXHTDiff || 0})</sup><br />
              - {b.stakingPZCX || 0} pZCX <sup>({b.stakingPZCXDiff || 0})</sup><br />
              {b.stakingPZCXHT || 0} pZCXHT <sup>({b.stakingPZCXHTDiff || 0})</sup></small></td>
            </tr>
            <tr>
              <td>Burned</td>
              <td>- {b.burned || 0} ZCX</td>
            </tr>
            <tr>
              <td>Bridged to Poly</td>
              <td>
                ({b.totalBridged || 0} ZCX)<br />
                <small>{b.bridgedZCX || 0} ZCX<br />
                {b.bridgedZCXHT || 0} ZCXHT</small>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>Circulating Supply</td>
              <td>= {b.circulating||0} ZCX</td>
            </tr>
            <tr>
              <td>Market Cap (${b.price||0} per ZCX)</td>
              <td>= {b.mc||0} USD</td>
            </tr>
            <tr>
              <td>FDV</td>
              <td>= {b.fdv||0} USD</td>
            </tr>
          </tfoot>
        </table>
    );
  }

  useEffect(async () => {
    await fetchData();
    //await fetchHistoricData(5);
  },[]);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Real Circulating $ZCX Supply</h1>
        <p>This quick overview shows the real supply of <a href="http://unizen.io">unizen.io</a> utility token $ZCX</p>
        <ShowBalanceTable b={balances} />
        <hr />
        <h5>Historic data (past 5 days)</h5>
        <p>Not exact on the minute, it calculates estimates based on block time of both chains</p>
        <button onClick={(e) => { e.preventDefault(); fetchHistoricData(5); }}>Load historic data</button>
        <br />
        <ShowHistoricTable b={historic} />
        <p className="small">* Price provided by <a href="http://coingecko.com/">coingecko.com</a></p>
      </header>
      
    </div>
  );
}

export default App;